import { FeatureKey } from 'common/constants/permission'
import compact from 'lodash/compact'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import BacteriaRecordDialog from '../components/BacteriaRecordDialog'
import MineralRecordDialog from '../components/MineralRecordDialog'
import WaterQualityDialog from '../components/WaterQualityDialog'
import { waterTableFilterState } from '../stores/atom'
import { useMutateDeleteWaterMineral, useMutateDeleteWaterVibrio } from './mutation'
import {
  useGetWaterBacteriaLineChart,
  useGetWaterBacterias,
  useGetWaterMineralLineChart,
  useGetWaterMinerals,
  useGetWaterQualities,
  useGetWaterQualityLineChart,
} from './queries'
import { DisplayMode } from './types'

export type WaterQueryParams = {
  startDate?: string | Date | null
  endDate?: string | Date | null
}

export const useWaterQualities = (mode: DisplayMode, params?: WaterQueryParams) => {
  const { data, ...rest } = useGetWaterQualities(mode, params)
  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.water).flat()),
    }),
    [data, mode]
  )
}

export const useWaterMinerals = (mode: DisplayMode, params?: WaterQueryParams) => {
  const { data, ...rest } = useGetWaterMinerals(mode, params)
  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.minerals).flat()),
    }),
    [data, mode]
  )
}

export const useWaterBacterias = (mode: DisplayMode, params?: WaterQueryParams) => {
  const { data, ...rest } = useGetWaterBacterias(mode, params)
  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.bacterias).flat()),
    }),
    [data, mode]
  )
}

export const useWaterTable = (params?: WaterQueryParams) => {
  const filter = useRecoilValue(waterTableFilterState)
  switch (filter) {
    case FeatureKey.WaterVibrio:
      return (mode: DisplayMode) => useWaterBacterias(mode, params)
    case FeatureKey.WaterMineral:
      return (mode: DisplayMode) => useWaterMinerals(mode, params)
    case FeatureKey.WaterQuality:
    default:
      return (mode: DisplayMode) => useWaterQualities(mode, params)
  }
}

export const useMutateDeleteWater = () => {
  const filter = useRecoilValue(waterTableFilterState)
  switch (filter) {
    case FeatureKey.WaterVibrio:
      return useMutateDeleteWaterVibrio
    case FeatureKey.WaterMineral:
    default:
      return useMutateDeleteWaterMineral
  }
}

export const useGetWaterChart = () => {
  const filter = useRecoilValue(waterTableFilterState)
  switch (filter) {
    case FeatureKey.WaterVibrio:
      return useGetWaterBacteriaLineChart
    case FeatureKey.WaterMineral:
      return useGetWaterMineralLineChart
    case FeatureKey.WaterQuality:
    default:
      return useGetWaterQualityLineChart
  }
}

export const useWaterEditDialog = () => {
  const filter = useRecoilValue(waterTableFilterState)
  switch (filter) {
    case FeatureKey.WaterVibrio:
      return BacteriaRecordDialog
    case FeatureKey.WaterMineral:
      return MineralRecordDialog
    case FeatureKey.WaterQuality:
    default:
      return WaterQualityDialog
  }
}
